import React, {useState} from 'react'
import {Button, Input, Popover} from "antd";
import './styles.scss'
import {EditTwoTone} from "@ant-design/icons";
import useBoolean from "../../../Utils/useBoolean";

function UpdatePortProxies ({value, title, updateProxies, rec, fieldsChange}) {
    const [initial, setValue] = useState(value)
    const {toggleValue: changeVisible, value: visible} = useBoolean(false)

    const handleSave = () => {
        const params = {
            id: rec.id,
        }
        changeVisible()
        fieldsChange.forEach(e => params[e] = rec[e] || "")
        params.port = +initial
        updateProxies(params)
    }
    return (
      <Popover
        title="Update Port"
        trigger="click"
        open={visible}
        onOpenChange={changeVisible}
        content={
          <div className="proxies_change">
            <Input type="number"
              defaultValue={initial}
              onChange={(e) => setValue(e.target.value)}
            />
            <div className={"ml updateProxiesButton"} style={{height: 32}}>
              <Button
                color="default"
                variant="contained"
                onClick={changeVisible}
              >
              cancel
              </Button>
              <Button
                color="primary"
                // variant="contained"
                disabled={initial === value}
                style={initial !== value ? { backgroundColor: "#1890ff", color: "white"} : {}}
                onClick={handleSave}
              >
                save
              </Button>
            </div>
          </div>
        }
      >
          <Popover content={'Edit ' + title}>
              <div>
                  {value}
                  <EditTwoTone
                      className={"anticonProxy"}
                      style={{
                          position: 'absolute',
                          top: '50%',
                          left: 'calc(100% - 15px)',
                          transform: 'translateY(-50%)',
                      }}
                  />
              </div>
          </Popover>
      </Popover>
    );
}
export default UpdatePortProxies
